import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'utcToLocal',
  standalone: false
})
export class UtcToLocalPipe implements PipeTransform {
  /**
   * Converts a UTC timestamp to the user's local system time.
   * @param value The UTC date string or Date object
   * @param format Optional moment format string (defaults to 'MMM D, YYYY h:mm A')
   */
  transform(value: string | Date | undefined | null, format: string = 'MMM D, YYYY h:mm A'): string {
    if (!value) return '—';
    
    // Ensure moment treats the input as UTC
    // If it's a string without timezone info, append ' UTC'
    const utcValue = (typeof value === 'string' && !value.endsWith('Z') && !value.includes('+')) 
      ? value + ' UTC' 
      : value;
      
    const localMoment = moment(utcValue).local();
    
    if (!localMoment.isValid()) {
      return value.toString();
    }
    
    return localMoment.format(format);
  }
}
